export enum TaxonomyType {
  ARCHETYPE = 'ARCHETYPE',
  TPI_SCREEN = 'TPI_SCREEN',
  SB_GOAL = 'SB_GOAL',
  EQUIPMENT = 'EQUIPMENT',
  PATTERN = 'PATTERN',
  CATEGORY = 'CATEGORY',
  POSITION = 'POSITION',
}

export interface Taxonomy {
  id: string;
  type: TaxonomyType;
  value: string;
  description?: string;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TaxonomyDimensionConfig {
  type: TaxonomyType;
  allowInlineCreate: boolean;
}
